<template>
  <div>
    <v-col class="modalColPadding">
      <p class="modalXMargin titleModal">
        {{ $t('forms.labels.name') }}
      </p>
    </v-col>
    <v-row class="modalXMargin">
      <v-col
        class="modalColPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="member.firstName"
          outlined
          :label="$t('forms.labels.firstName')"
          :rules="{ required: true, min: 1, max: 200 }"
          data-cy="inviteForm-firstName"
          @input="updateData"
        />
      </v-col>
      <v-col
        class="modalColPadding"
        cols="12"
        sm="6"
      >
        <VTextField
          v-model="member.lastName"
          outlined
          :label="$t('forms.labels.lastName')"
          :rules="{ required: true, min: 1, max: 200 }"
          data-cy="inviteForm-lastName"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-col class="modalColPadding">
      <p class="modalXMargin titleModal">
        {{ $t('forms.labels.phone') }}
      </p>
    </v-col>
    <v-row class="modalXMargin phoneNumber">
      <v-col class="modalColPadding">
        <PhoneNumberInput
          :refObserver="$refs.observer"
          :value="member.phoneNumber.number"
          :isPhoneNumberValid="isPhoneNumberValid"
          data-cy="inviteForm-phone"
          @inputChanged="phoneInput"
        />
      </v-col>
    </v-row>
    <v-col class="modalColPadding">
      <p class="modalXMargin titleModal">
        {{ $t('forms.labels.email') }}
      </p>
    </v-col>
    <v-row class="modalXMargin">
      <v-col
        class="modalColPadding"
        cols="12"
        sm="8"
      >
        <VTextField
          v-model="member.email"
          outlined
          :label="$t('forms.labels.email')"
          :type="'email'"
          :rules="{ required: true, min: 1, max: 200, email: true }"
          data-cy="inviteForm-email"
          @input="updateData"
        />
      </v-col>
      <v-col
        class="modalColPadding"
        cols="12"
        sm="4"
      >
        <VSelect
          v-model="member.locale"
          outlined
          :label="$t('forms.labels.emailLang')"
          :items="lang"
          itemValue="key"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <div v-if="client">
      <v-col class="modalColPadding">
        <p class="modalXMargin titleModal">
          {{ $t('forms.labels.settings') }}
        </p>
      </v-col>
      <v-row class="modalXMargin">
        <v-col
          class="modalColPadding"
          cols="12"
          sm="6"
        >
          <VAutocomplete
            v-model="member.roles"
            itemValue="value"
            outlined
            :label="$t('forms.labels.roles')"
            :items="roles"
            multiple
            :filter="null"
            :rules="{ required: true }"
            data-cy="inviteForm-rolesSelect"
            @change="updateData"
          />
        </v-col>
      </v-row>
      <v-row class="modalXMargin">
        <v-col class="modalColPadding">
          <VAutocomplete
            v-model="member.selectedSites"
            outlined
            :label="$t('forms.labels.sites')"
            :items="sites"
            multiple
            data-cy="sitesSelect"
            @change="updateData"
          />
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-row class="modalXMargin">
        <v-col class="modalColPadding">
          <VAutocomplete
            v-model="member.roles"
            :label="$t('forms.labels.roles')"
            :items="roles"
            outlined
            :multiple="false"
            itemText="label"
            itemValue="value"
            :rules="{ required: true }"
            data-cy="inviteForm-rolesSelect"
            @change="updateData"
          />
        </v-col>
      </v-row>
    </div>
    <v-row
      v-if="superAdmin"
      class="modalXMargin"
    >
      <v-col class="modalColPadding">
        <VCheckbox
          v-model="member.excludeInBilling"
          class="d-flex"
          :label="$t('forms.labels.excludeInBilling')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import PhoneNumberInput from '@/components/shared/widgets/forms/PhoneNumberInput.vue';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import VCheckbox from '@/components/shared/widgets/forms/VuetifyInputs/VCheckbox.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        VCheckbox,
        VAutocomplete,
        VTextField,
        VSelect,
        PhoneNumberInput,
    },
    props: {
        role: {
            type: String,
            default: '',
        },
        roles: {
            type: Array,
            default: () => [],
        },
        client: {
            type: String,
            default: null,
        },
        sites: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            lang: [
                {
                    key: 'en',
                    name: 'English',
                },
                {
                    key: 'fr',
                    name: 'Français',
                },
            ],
            member: {
                firstName: null,
                lastName: null,
                email: null,
                phoneNumber: { number: '' },
                locale: this.$store.getters.lang,
                roles: this.role && this.role !== 'all' ? [this.role] : [],
                client: this.client,
                selectedSites: [],
                excludeInBilling: false,
            },
            isPhoneNumberValid: true,
        };
    },
    computed: {
        ...mapGetters([
            'superAdmin',
        ]),
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.member);
        },
        phoneInput(number, payload) {
            this.member.phoneNumber = !number ? {} : payload;
            this.isPhoneNumberValid = payload.valid;
            this.updateData();
        },
    },
};
</script>
<style lang="scss" scoped>
.phoneNumber{
  margin-bottom: 40px;
}
</style>
